import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';

//comercial
const firebaseConfig = {
    apiKey: "AIzaSyBfySMboMP79Qj4rsqxGbgKknLWRT6iAfY",
  authDomain: "conveniosbienestarmimbral.firebaseapp.com",
  projectId: "conveniosbienestarmimbral",
  storageBucket: "conveniosbienestarmimbral.appspot.com",
  messagingSenderId: "70565736098",
  appId: "1:70565736098:web:8b84a52d833b980a0271fb",
  measurementId: "G-VG4MWENWDP"
}


/*
//transportes
const firebaseConfig = {
  apiKey: "AIzaSyBr3c_PiD6sP06stgyM0vsXeREw73W_Qw4",
  authDomain: "entrada-73193.firebaseapp.com",
  databaseURL: "https://entrada-73193.firebaseio.com",
  projectId: "entrada-73193",
  storageBucket: "entrada-73193.appspot.com",
  messagingSenderId: "981795656620",
  appId: "1:981795656620:web:637b194219b625d3bae009",
  measurementId: "G-83M2S0RE6S"
};*/

const firebaseApp = firebase.initializeApp(firebaseConfig);
//const storage=firebase.storage();
export const db = firebaseApp.firestore();
export const  storage=firebase.storage();
/*export {
    storage    
}*/